import { vservice } from '@niknevis/vue-modules'
import {
  ContentItemContentResourceType,
  ContentItemResourceType
} from '@/modules/content-item/models/content-item-resource.model'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { PanelContentItemRoute } from '@/modules/content-item/routes/panel-content-item.route'
import { ContentItemStatusChangeRequestModel } from '@/modules/content-item/models/content-item-request.model'
import { Data } from '@/modules/shared/models/data'
import { ContentItemCollectionModel } from '@/modules/content-item/models/content-item-collection.model'

@vservice()
export class PanelContentItemService {
  constructor(
    private readonly routes: PanelContentItemRoute
  ) {
  }

  show(itemId: number): Promise<ContentItemResourceType> {
    return HTTP
      .get(this.routes.show(itemId))
      .then(response => response.json())
  }

  showContent(itemId: number): Promise<ContentItemContentResourceType> {
    return HTTP
      .get(this.routes.showContent(itemId))
      .then(response => response.json())
  }

  sendToRejected(itemId: number, data: ContentItemStatusChangeRequestModel) {
    return Inertia
      .put(
        this.routes.sendToRejected(itemId),
        data
      )
  }

  getItems(data): Promise<Data<ContentItemCollectionModel[]>> {
    return HTTP.get(
      this.routes.getItems(),
      {
        searchParams: data
      }
    ).then(result => result.json())
  }


}
